import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import style from './AccrualChart.module.scss';

export default function AccrualChart(props) {
  const { dataChart, isExport } = props;
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(dataChart);
    }
    console.log('Log: ~ file: AccrualChart.jsx ~ line 23 ~ AccrualChart ~ dataChart', dataChart);
  }, [dataChart]);

  const updateDataset = (listOne) => {
    chartInstance.data.datasets = installDataset(listOne);
    chartInstance.update();
  };

  const installDataset = (listOne) => {
    let newList = [
      {
        type: 'line',
        unit: 'kWh',

        label: 'Quantity',
        data: listOne.estimated,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        backgroundColor: '#ff3c2e',
        borderColor: '#ff3c2e',
        borderWidth: 2,
      },
      {
        type: 'line',
        unit: 'kWh',
        label: 'Plan',
        data: listOne.energy,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        borderColor: '#038cfc',
        borderWidth: 2,
        backgroundColor: '#038cfc',
      },
    ];
    return newList;
  };

  const data = {
    datasets: [
      {
        type: 'line',
        unit: 'kWh',

        label: 'Quantity',
        data: dataChart.estimated,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        backgroundColor: '#ff3c2e',
        borderColor: '#ff3c2e',
        borderWidth: 2,
      },
      {
        type: 'line',
        label: 'Plan',
        unit: 'kWh',
        data: dataChart.energy,
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        borderColor: '#038cfc',
        borderWidth: 2,
        backgroundColor: '#038cfc',
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      elements: {
        point: {
          radius: 0,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      maintainAspectRatio: false,
      plugins: {
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        legend: {
          display: true,
          // position: isExport ? 'right' : 'top',
          labels: {
            // This more specific font property overrides the global property
            font: {
              size: isExport ? 8 : 14,
            },
            color: '#000',
          },
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
          time: {
            unit: 'month',
          },
          ticks: {
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
            },
            color: '#000',
          },
        },
        y: {
          title: {
            display: false,
            text: 'Temperature',
            font: {
              family: 'Times',
              size: isExport ? 8 : 14,
              style: 'normal',
              lineHeight: 1.2,
            },
            color: '#000',
          },
          ticks: {
            callback: function (value, index, values) {
              return `${value.toLocaleString()} kWh`;
            },
            font: {
              family: 'Times',
              size: isExport ? 8 : 16,
              style: 'normal',
            },
            color: '#000',
          },
        },
      },
    },
  };

  return (
    <div
      className={clsx(style.chart, {
        [style.chart_export]: isExport,
      })}
    >
      <canvas ref={chartRef} />
    </div>
  );
}
AccrualChart.propTypes = {
  isExport: PropTypes.bool,
  dataChart: PropTypes.shape({
    estimated: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        value: PropTypes.number,
      })
    ),
    energy: PropTypes.arrayOf(
      PropTypes.shape({
        ts: PropTypes.number.isRequired,
        value: PropTypes.number,
      })
    ),
  }).isRequired,
};
